import { InputAdornment, IconButton } from '@mui/material';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import { useState } from 'react';

import { TextInputForm } from '../';
import { TextInputFormProps } from '../textInputForm/types';

const PasswordForm = (props: TextInputFormProps) => {
  const {
    value,
    setValue,
    isValid,
    setIsValid,
    validate,
    errorMessage,
    ...options
  } = props;

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <TextInputForm
      label={'パスワード'}
      type={isPasswordVisible ? 'text' : 'password'}
      value={value}
      setValue={setValue}
      isValid={isValid}
      setIsValid={setIsValid}
      validate={validate}
      errorMessage={errorMessage}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              onClick={() => {
                setIsPasswordVisible(!isPasswordVisible);
              }}
              onMouseDown={(event) => {
                event.preventDefault();
              }}
              edge='end'
              sx={{
                backgroundColor: 'transparent',
              }}
            >
              {isPasswordVisible ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...options}
    />
  );
};

export default PasswordForm;
